import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/branch";

export class GetBranchInstallationsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor(branchId: number) {
        super();
        this.endPoint += `/${branchId}/installations`;
    }

    public async execute(): Promise<GetBranchInstallationsResData> {
        var res = await this.executeCommand();
        return new GetBranchInstallationsResData(res);
    }
}

export class GetBranchInstallationsResData extends ApiGenericResponse {
    installationNames: string[];

    constructor(response: AxiosResponse) {
        super(response);
        this.installationNames = [];

        if (response.data && response.data.Payload && Array.isArray(response.data.Payload.InstallationNames) && response.data.Payload.InstallationNames.length)
            this.installationNames = response.data.Payload.InstallationNames;
    }
}
